import { useCallback, useState } from "react";

export const useArticleItem = () => {
	const [open, setOpen] = useState(false);

	const handleOpenChange = useCallback((input: boolean) => {
		setOpen(input);
	}, []);

	const activateArticleModal = useCallback(() => {
		setOpen(true);
	}, []);

	return {
		open,
		handleOpenChange,
		activateArticleModal,
	};
};
